import { cn } from "@/lib/utils";

const CARD_SHADOW =
  "shadow-[0_2px_4px_rgba(0,0,0,0.04),0_8px_20px_rgba(0,0,0,0.07),0_20px_48px_rgba(0,0,0,0.07)]";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const FormCard = ({ children, className }: Props) => (
  <div className={cn("bg-white rounded-[1.25rem] w-full", CARD_SHADOW, className)}>
    {children}
  </div>
);
